import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { EndpointCreatePage } from '@/features/admin/endpoints/endpoint-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvel endpoint de serving (porting README #53). */
export const Route = createFileRoute('/$tenant/projects/$projectId/endpoints/new')({
  component: NewEndpointRoute,
});

function NewEndpointRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="endpoints"
      crumbs={[{ label: t('nav.items.endpoints') }, { label: t('admin.endpoints.newTitle') }]}
    >
      <EndpointCreatePage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
